import ApiService from "./api.service";

const importantEvents = {
  add: async function (constructionId, importantEvent) {
    let response = await ApiService.post("/construction/" + constructionId + '/events', importantEvent);
    return response.data.important_events;
  },
  update: async function (constructionId, importantEvents) {
    let response = await ApiService.patch("/construction/" + constructionId + '/events', { important_events: importantEvents });
    return response.data.important_events;
  },

};

export default importantEvents;